import { create } from 'zustand'

interface Toast {
  id: number
  message: string
  type: 'error' | 'info'
  time: Date
}

interface ToastState {
  toasts: Toast[]
  log: Toast[]
  logOpen: boolean
  nextId: number
  showError: (message: string) => void
  showInfo: (message: string) => void
  dismiss: (id: number) => void
  toggleLog: () => void
  clearLog: () => void
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  log: [],
  logOpen: false,
  nextId: 1,
  showError: (message) => {
    const id = get().nextId
    const entry: Toast = { id, message, type: 'error', time: new Date() }
    set(s => ({
      toasts: [...s.toasts, entry],
      log: [entry, ...s.log].slice(0, 200),
      nextId: id + 1,
    }))
    setTimeout(() => get().dismiss(id), 8000)
  },
  showInfo: (message) => {
    const id = get().nextId
    const entry: Toast = { id, message, type: 'info', time: new Date() }
    set(s => ({
      toasts: [...s.toasts, entry],
      log: [entry, ...s.log].slice(0, 200),
      nextId: id + 1,
    }))
    setTimeout(() => get().dismiss(id), 5000)
  },
  dismiss: (id) => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),
  toggleLog: () => set(s => ({ logOpen: !s.logOpen })),
  clearLog: () => set({ log: [], logOpen: false }),
}))

export const toast = {
  error: (message: string) => useToastStore.getState().showError(message),
  info: (message: string) => useToastStore.getState().showInfo(message),
}
